<template>
  <div>
    <!-- <div class="show-txt" v-if="!isFoucs" @click="getBlur">
      <span class="only-value" v-if="currentValue && currentValue.length > 0">
        <span>{{currentValue}}</span>
      </span>
      <span class="add-txt" v-else>任务状态</span>
    </div>
    <el-select v-else class="hover-style-show" :automatic-dropdown="true" ref="status" v-model="currentValue" @change="valueChange" placeholder="请选择" @visible-change="visibleSelect">
      <el-option v-for="item in taskStageList" :key="item" :label="item" :value="item">
      </el-option>
    </el-select> -->
    <div class="show-txt" :class="{'show-txt-rest':readonly}">
      <span class="only-value">
        <span>{{currentValue}}</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['config', 'value', 'onlyValue', 'defaultValue'],
  data() {
    return {
      isFoucs: false,
      taskStageList: ['未开始', '进行中', '已完成', '已归档'],
    }
  },
  computed: {
    currentValue: {
      get: function () {
        return this.value || [];
      },
      set: function (newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  methods: {
    visibleSelect(val) {
      if (!val) {
        this.isFoucs = false
      }
    },
    valueChange(val) {
      this.$emit('change', val)
    },
    getBlur() {
      this.isFoucs = true
      this.$nextTick(() => {
        this.$refs.status.focus()
      })
    },
  }
}
</script>

<style>
</style>
